// src/components/auth/Login.js
import React, { useEffect, useState } from "react";
import { login } from "../../api/auth";
import { useNavigate } from 'react-router-dom';
import { useUser } from "../../api/AuthContext";
import Footer from "../Shared/Footer";
import Modal from "../Shared/Modal";


const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { setUser } = useUser();
  const [isProcessing, setIsProcessing] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const signupSuccess = urlParams.get('signup') === 'success';


  const handleLogin = async (event) => {
    event.preventDefault();
    setIsProcessing(true);
    try {
      await login(username, password, setUser);
      setIsProcessing(false)
      window.location.href = "/user/";
    } catch (err) {
    setIsProcessing(false);
      setError(err);
    }
  };

  return (
    <div>
        {/* <SignupSuccessModal /> */}
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
            <div className="row">
                <div className="col-12">
                    <div className="breadcrumb-contain">
                        <h2 className="mb-2">Log In</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/">
                                        <i className="fa-solid fa-house"></i>
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Log In</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Breadcrumb Section End --> */}

    {/* <!-- log in section start --> */}
    <section className="log-in-section background-image-2 section-b-space">
        <div className="container-fluid-lg w-100">
            <div className="row">
                <div className="col-xxl-6 col-xl-5 col-lg-6 d-lg-block d-none ms-auto">
                    <div className="image-contain">
                        <img src="../assets/images/inner-page/login.png" className="img-fluid" alt="" />
                    </div>
                </div>

                <div className="col-xxl-4 col-xl-5 col-lg-6 col-sm-8 mx-auto">
                    <div className="log-in-box">
                        <div className="log-in-title">
                            <h3>Welcome To Reducarb</h3>
                            <h4>Log In Your Account</h4>
                        </div>

                        <div className="input-box">
                            <form className="row g-4" onSubmit={handleLogin}>
                                <div className="col-12">
                                    <div className="form-floating theme-form-floating log-in-form">
                                        <input type="text" placeholder="Username" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} />
                                        {/* <label htmlFor="username">Username</label> */}
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-floating theme-form-floating log-in-form">
                                        <input type="password" className="form-control" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                        {/* <label htmlFor="password">Password</label> */}
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="forgot-box">
                                        <div className="form-check ps-0 m-0 remember-box">
                                            {/* <input className="checkbox_animated check-box" type="checkbox"
                                                id="flexCheckDefault" />
                                            <label className="form-check-label" htmlFor="flexCheckDefault">Remember me</label> */}
                                        </div>
                                        <a href="/forgot-password" className="forgot-password">Forgot Password?</a>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <button className="btn btn-md cart-button text-white w-100 justify-content-center"
                                    
                        style={{
                          backgroundColor: "#3150A3",
                          fontWeight: "bold",
                        }}type="submit">

{isProcessing ? (
            <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Processing...
            </>
        ) : (
            "Login"
        )}

                        </button>
                                    {error && <p style={{ color: "red" }}>{error}</p>}
                                </div>
                            </form>
                        </div>

                        <div className="sign-up-box">
                            <h4>Don't have an account?</h4>
                            <a href="sign-up">Sign Up</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- log in section end --> */}

    {signupSuccess && (
        <Modal
          title="Signup Successful!"
          modalType="success"
          bodyText="Welcome! Your signup was successful. Please log in to continue."
          modalId="loginModal"
        />
      )}

    <Footer/>
    </div>
  );
};

export default Login;
